export default __webpack_public_path__ + "static/media/studying-1.d36aff3c.png";